import React, { useState } from 'react';
import { JURIDICAL_DATA } from './archiveData';

export const JuridicalGnosis: React.FC = () => {
  const [copied, setCopied] = useState<boolean>(false);

  const handleCopyDemurrer = async () => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(JURIDICAL_DATA.demurrerText);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = JURIDICAL_DATA.demurrerText;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback
    }
  };

  return (
    <div className="space-y-8 animate-fade-in" id="juridical-gnosis-section">
      <div className="border-b border-iron-dark pb-4">
        <div className="flex items-center gap-2 text-xs font-mono text-gold-ancient uppercase tracking-widest">
          <span>LIBER SECUNDUS</span>
          <span>•</span>
          <span>JURIDICAL GNOSIS</span>
        </div>
        <h2 className="font-display text-2xl sm:text-3xl text-parchment-light uppercase mt-1">
          {JURIDICAL_DATA.title}
        </h2>
        <p className="text-xs sm:text-sm text-parchment-dim mt-2 max-w-3xl">
          {JURIDICAL_DATA.subtitle}
        </p>
      </div>

      {/* Historical Breakdown */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {JURIDICAL_DATA.historicalAnalysis.map((item, idx) => (
          <div key={idx} className="chthonic-card rounded-lg p-6 space-y-3">
            <span className="text-[10px] font-mono text-gold-ancient uppercase tracking-widest">
              PARAGRAPH {idx + 1}
            </span>
            <h3 className="font-display text-base text-parchment-light font-semibold">
              {item.heading}
            </h3>
            <p className="text-xs text-parchment-dim leading-relaxed font-serif">
              {item.content}
            </p>
          </div>
        ))}
      </div>

      {/* Theoretical Pillars of Forensic Magic */}
      <div className="rounded-lg border border-iron-dark bg-obsidian-surface/70 p-6 sm:p-8 space-y-6">
        <h3 className="font-display text-lg text-gold-bright uppercase tracking-wide">
          Theoretical Architecture of Forensic Boundary Magic
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {JURIDICAL_DATA.theoreticalPrinciples.map((principle) => (
            <div key={principle.id} className="space-y-2 border-l-2 border-bronze-base/70 pl-4">
              <h4 className="font-display text-xs sm:text-sm font-semibold text-parchment-light">
                {principle.title}
              </h4>
              <p className="text-xs text-parchment-dim leading-relaxed">
                {principle.summary}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* The Operative Demurrer Liturgical Document */}
      <div className="chthonic-card rounded-lg p-6 sm:p-8 lg:p-10 space-y-6 shadow-chthonic">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-iron-dark pb-4">
          <div>
            <span className="text-[10px] font-mono text-ember-spark uppercase tracking-widest">
              INSTRUMENTUM FORENSE
            </span>
            <h3 className="font-display text-xl text-gold-bright">
              The Plea of Absolute Demurrer (Libellus Demurreris Chythonii)
            </h3>
          </div>
          <button
            onClick={handleCopyDemurrer}
            className="btn-gold px-4 py-2 text-xs font-semibold rounded self-start sm:self-auto"
          >
            {copied ? 'DEMURRER COPIED' : 'COPY DEMURRER TEXT'}
          </button>
        </div>

        <div className="rounded border border-iron-dark/80 bg-obsidian-deep/95 p-6 sm:p-8 font-mono text-xs text-parchment-base leading-relaxed overflow-x-auto">
          <pre className="whitespace-pre-wrap font-mono text-[11px] sm:text-xs">
            {JURIDICAL_DATA.demurrerText}
          </pre>
        </div>

        <div className="flex items-center justify-between text-[11px] font-mono text-iron-steel border-t border-iron-dark/60 pt-4">
          <span>COURT SEAL: SINE IUGO SINE DOMINO</span>
          <span>ENTERED INTO CHYTHONIC RECORD</span>
        </div>
      </div>
    </div>
  );
};

export default JuridicalGnosis;
